import { View } from "backbone";
/* eslint-disable
    constructor-super,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-param-reassign,
    no-shadow,
    no-this-before-super,
    no-underscore-dangle,
    no-unused-expressions,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let EditorialMenu;
export default EditorialMenu = class EditorialMenu extends View {
  initialize(options) {
    this._toggle = this._toggle.bind(this);
    if (options == null) { options = {}; }
    this.editorialMenu = this.$el.find(".editorial-menu");
    return this.editorialMenu.find(".toggle").on("click", this._toggle);
  }

  _toggle(event) {
    event.preventDefault();
    return this.editorialMenu.toggleClass("opened");
  }
};
